import { useNavigation, useRoute } from '@react-navigation/native';
import React from 'react';
import ErrorBoundary from 'src/components/10-atoms/ErrorBoundary';
import ScreenErrorFallback from 'src/components/10-atoms/ErrorBoundary/ScreenErrorFallback';
/**
 * Isolates a route/screen so a render crash cannot take down the app shell.
 * Resets when the route key changes (navigation to a different screen instance).
 */
export default function withScreenErrorBoundary(Component) {
    const ScreenWithErrorBoundary = props => {
        const route = useRoute();
        const navigation = useNavigation();
        return (React.createElement(ErrorBoundary, { resetKeys: [route.key], renderError: (_error, { resetError }) => (React.createElement(ScreenErrorFallback, { onRetry: resetError, onGoBack: navigation.canGoBack() ? () => navigation.goBack() : undefined })) },
            React.createElement(Component, { ...props })));
    };
    ScreenWithErrorBoundary.displayName = `withScreenErrorBoundary(${Component.displayName || Component.name || 'Screen'})`;
    return ScreenWithErrorBoundary;
}
